module.exports = __webpack_public_path__ + "assets/img/36_562.fc499f66.jpg";